import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';

/**
 * CW-13d-admin — cookie-auth interceptor rewrite (AW-12 HIGH).
 *
 * For every request to the admin API origin, set `withCredentials: true`
 * so the browser attaches the `tb_admin_access` HttpOnly cookie. No bearer-
 * header injection — the legacy header-token path is gone.
 *
 * Non-API URLs (assets, third-party endpoints) are passed through
 * untouched: the cookie would not be sent cross-origin anyway, and we
 * avoid leaking credentials to allowed-storage S3 / CDN hosts.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }
  return next(req.clone({ withCredentials: true }));
};
